module.exports = __webpack_public_path__ + "img/hefty.812f07e2.svg";